import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { NavigationButton } from '../common/NavigationButton';
import Picture from '@/image/hotel/picture12.png';
import { getNeighborhoodsByProperty } from '@/API/apiService';
import { LocalizedLink } from 'src/components/common/LocalizedLink';

interface Tag {
  id: number;
  name: string;
  name_en: string;
}

interface Area {
  id: number;
  name: string;
  name_en: string;
}

interface Neighborhood {
  neighborhood_id: number;
  title: string;
  title_en: string;
  list_title: string;
  list_title_en: string;
  header_image_url: string;
  date_time: string;
  areas: Area[];
  tags: Tag[];
}

interface ImageCardProps {
  neighborhood: Neighborhood;
  useEnglish: boolean;
}

const ImageCard: React.FC<ImageCardProps> = ({ neighborhood, useEnglish }) => {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    (e.target as HTMLImageElement).src = Picture;
  };

  const displayListTitle =
    useEnglish && neighborhood.list_title_en
      ? neighborhood.list_title_en
      : neighborhood.list_title || 'No List Title';

  const displayTitle =
    useEnglish && neighborhood.title_en
      ? neighborhood.title_en
      : neighborhood.title || 'No Title';

  return (
    <div className="w-full md:w-[223px] md:h-[321px] text-center mb-4">
      <LocalizedLink to={`/magazine/${neighborhood.neighborhood_id}`}>
        <img
          src={neighborhood.header_image_url || Picture}
          alt={displayTitle}
          className="w-full h-auto mb-1"
          onError={handleImageError}
        />
      </LocalizedLink>
      <p className="text-[15px] text-left">{displayListTitle}</p>
      {/* <p className="mb-1 text-[12px] text-left">{displayTitle}</p> */}
      <div className="flex flex-wrap justify-start gap-1">
        {neighborhood.tags?.map((tag) => {
          const displayTag = useEnglish && tag.name_en ? tag.name_en : tag.name;
          return (
            <div key={tag.id} className="text-[9px] underline mt-3">
              {displayTag}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const MagazineParts: React.FC = () => {
  // useParams で URL から propertyId と lang を取得（例: /en/monthly/1）
  const { propertyId, lang } = useParams<{
    propertyId: string;
    lang: string;
  }>();
  const useEnglish = lang === 'en';

  const [neighborhoods, setNeighborhoods] = useState<Neighborhood[]>([]);

  useEffect(() => {
    // TODO: 1でいいのか要確認
    getNeighborhoodsByProperty(propertyId || '1')
      .then((res) => {
        if (res.data && Array.isArray(res.data.data)) {
          const sorted = [...res.data.data].sort((a, b) => {
            const timeA = new Date(a.date_time).getTime() || 0;
            const timeB = new Date(b.date_time).getTime() || 0;
            return timeB - timeA;
          });
          setNeighborhoods(sorted);
        }
      })
      .catch((error) => {
        console.error('Failed to fetch neighborhoods by property:', error);
      });
  }, [propertyId, useEnglish]);

  const longText_en = `
   Take a walk around our neighborhoods. Hear local voices and connect to the community.
  `;
  const longText_ja = `
  ガイドブックに載っていないローカルな場所を発見し、本当のネイバーフッドを知ることは結構難しい。
  ここでは、ネイバーフッド・トラベラーたちが行くべき選りすぐりの場所を紹介する。
  `;

  return (
    <div className="relative">
      <div className="mb-[46px] md:mt-[150px] text-center text-lg">
        (MAGAZINE)
      </div>
      <div className="max-w-[610px] mx-auto mb-4 text-base">
        {useEnglish ? <p>{longText_en}</p> : <p>{longText_ja}</p>}
      </div>
      <div className="grid w-full md:w-max grid-cols-2 md:grid-cols-4 gap-2 md:gap-4 justify-items-center mx-auto">
        {neighborhoods.slice(0, 4).map((item) => (
          <ImageCard
            key={item.neighborhood_id}
            neighborhood={item}
            useEnglish={useEnglish}
          />
        ))}
      </div>
      <div className="border-t border-black p-2 border w-fit mx-auto mt-4 text-[15px]">
        <NavigationButton
          to="/magazine"
          text={'View Magazine'}
          className="text-black"
        />
      </div>
    </div>
  );
};
